import { observer } from 'mobx-react-lite'
import type { AnyFilterEditor } from '@/features/legends/filters/filter-registry'
import { BinaryOperationFilterContainer } from '@/features/legends/filters/components/BinaryOperationFilter/BinaryOperationFilterContainer'
import { ConjunctionFilterContainer } from '@/features/legends/filters/components/ConjunctionFilter/ConjunctionFilterContainer'
import { ConstantFilterContainer } from '@/features/legends/filters/components/ConstantFilter/ConstantFilterContainer'
import { ExpressionFilterContainer } from '@/features/legends/filters/components/ExpressionFilter/ExpressionFilterContainer'
import { HasSkillsFilterContainer } from '@/features/legends/filters/components/HasSkillsFilter/HasSkillsFilterContainer'
import { IfFilterContainer } from '@/features/legends/filters/components/IfFilter/IfFilterContainer'

export interface FilterEditorContainerProps {
  vm: AnyFilterEditor
  isDisabled?: boolean
  testId?: string
}

/**
 * The editor for a filter of any type.
 */
export const FilterEditorContainer = observer(function FilterEditorContainer({
  vm,
  isDisabled,
  testId,
}: FilterEditorContainerProps) {
  switch (vm.type) {
    case 'BinaryOperation':
      return (
        <BinaryOperationFilterContainer
          vm={vm}
          isDisabled={isDisabled}
          testId={testId}
        />
      )
    case 'Conjunction':
      return (
        <ConjunctionFilterContainer
          vm={vm}
          isDisabled={isDisabled}
          testId={testId}
        />
      )
    case 'Constant':
      return (
        <ConstantFilterContainer
          vm={vm}
          isDisabled={isDisabled}
          testId={testId}
        />
      )
    case 'Expression':
      return (
        <ExpressionFilterContainer
          vm={vm}
          isDisabled={isDisabled}
          testId={testId}
        />
      )
    case 'HasSkills':
      return (
        <HasSkillsFilterContainer
          vm={vm}
          isDisabled={isDisabled}
          testId={testId}
        />
      )
    case 'If':
      return (
        <IfFilterContainer vm={vm} isDisabled={isDisabled} testId={testId} />
      )
  }
})
